import type { Anime } from "@/mocks/anime";
import { sortOptions, type SortValue } from "@/mocks/filters";

export const matchesKeyword = (anime: Anime, keyword: string) => {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return true;
  const haystack = [
    anime.title,
    anime.summary,
    anime.region,
    anime.studio,
    anime.status,
    ...anime.categories,
    ...anime.voiceCast,
  ]
    .join(" ")
    .toLowerCase();
  return haystack.includes(kw);
};

export const sortAnime = (list: Anime[], sort: SortValue): Anime[] => {
  const copy = [...list];
  switch (sort) {
    case "latest":
      return copy.sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
    case "rating":
      return copy.sort((a, b) => b.rating - a.rating);
    case "newest":
      return copy.sort((a, b) => b.year - a.year);
    default:
      return copy.sort((a, b) => b.popularity - a.popularity);
  }
};

export const sortLabel = (sort: SortValue) => {
  const found = sortOptions.find((item) => item.value === sort);
  return found ? found.label : sortOptions[0].label;
};

export const PAGE_SIZE = 8;

export const formatUpdated = (date: string) => {
  const parts = date.split("-");
  if (parts.length !== 3) return date;
  return `${Number(parts[1])} 月 ${Number(parts[2])} 日`;
};

export const padNo = (value: number) => String(value).padStart(2, "0");